export default "__VITE_ASSET__c6c2b874__"